import React from "react";
import { Row, Col, Table } from "react-bootstrap";
import FormattedDate from "shared/components/FormattedDate";
import _isEmpty from "lodash/isEmpty";

export default function SampleOrders(props) {
  const { sampleOrders, isMerchant } = props;

  const sampleOrderTableBody = sampleOrders.map((sampleOrder, index) => {
    return (
      <SampleOrderTableRow
        key={`sample-order-table-row-${sampleOrder.id}`}
        index={index}
        sampleOrder={sampleOrder}
        isMerchant={isMerchant}
      />
    );
  });

  return (
    <Row>
      <Col xs={12} md={12}>
        <Table striped>
          <thead>
            <SampleOrderTableHeader />
          </thead>
          <tbody>{sampleOrderTableBody}</tbody>
        </Table>
      </Col>
    </Row>
  );
}

const SampleOrderTableHeader = props => {
  return (
    <tr>
      <th>#</th>
      <th>Produkt</th>
      <th>Datum</th>
      <th>Adresse</th>
      <th>Status</th>
      {props.isMerchant === false && <th>Aktion</th>}
    </tr>
  );
};

const SampleOrderTableRow = props => {
  const { index, sampleOrder, isMerchant } = props;

  return (
    <tr key={sampleOrder.id}>
      <td>{index + 1}</td>
      <td>{sampleOrder.product.name}</td>
      <td>
        <FormattedDate date={sampleOrder.createdAt} />
      </td>
      <td>
        <SampleOrderAddress
          recipientName={sampleOrder.shippingAddressRecipientName}
          recipientAddition={sampleOrder.shippingAddressRecipientAddition}
          street={sampleOrder.shippingAddressStreet}
          streetAddition1={sampleOrder.shippingAddressStreetAddition1}
          streetAddition2={sampleOrder.shippingAddressStreetAddition2}
          city={sampleOrder.shippingAddressCity}
          postalCode={sampleOrder.shippingAddressPostalCode}
          stateCode={sampleOrder.shippingAddressStateCode}
          countryCode={sampleOrder.shippingAddressCountryCode}
          otherDetails={sampleOrder.shippingAddressOtherDetails}
        />
      </td>
      <td>{sampleOrder.status}</td>
      {isMerchant === false && (
        <td>
          <a href={`sample_orders/${sampleOrder.id}/edit`}>Editieren</a>
        </td>
      )}
    </tr>
  );
};

const SampleOrderAddress = props => {
  const {
    recipientName,
    recipientAddition,
    street,
    city,
    postalCode,
    otherDetails,
  } = props;

  if (
    _isEmpty(recipientName) &&
    _isEmpty(street) &&
    _isEmpty(city) &&
    _isEmpty(postalCode)
  ) {
    return <span>Keine Adresse hinterlegt!</span>;
  }

  return (
    <span>
      {recipientName} <br />
      {recipientAddition && (
        <span>
          {recipientAddition}
          <br />
        </span>
      )}
      {street}
      <br />
      {postalCode} {city}
      <br />
      {otherDetails}
    </span>
  );
};
